import * as tslib_1 from "tslib";
import { Base } from "../../components/base-component";
import { AnalyticsService } from "../../services/analytics.service";
import { TooltipsService } from "../../services/tooltips.service";
import "./form-item-report-death-details-v2.component.scss";
import "bootstrap-datepicker";
var FormItemReportDeathDetailsV2 = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemReportDeathDetailsV2, _super);
    function FormItemReportDeathDetailsV2(element) {
        var _this = _super.call(this, element) || this;
        _this.needForAssistanceVal = "";
        _this.needForEstateAdministerVal = "";
        _this.emailAddress = [
            {
                name: "Western_Cape",
                email: "enterprisedirect.westerncape@standardbank.co.za",
            },
            {
                name: "Mpumalanga",
                email: "enterprisemp@standardbank.co.za",
            },
            {
                name: "Eastern_Cape",
                email: "enterprisedirect.easterncape@standardbank.co.za ",
            },
            {
                name: "North_West",
                email: "directcst.northwest@standardbank.co.za",
            },
            {
                name: "Free_State",
                email: "enterprisedirectfsnc@standardbank.co.za",
            },
            {
                name: "Kwa_Zulu_Natal",
                email: "directlifestylesupportkzn@standardbank.co.za ",
            },
            {
                name: "Limpopo",
                email: "enterpriselp@standardbank.co.za",
            },
            {
                name: "Northern_Cape",
                email: "enterprisedirectfsnc@standardbank.co.za",
            },
            {
                name: "Ekurhuleni",
                email: "ekurhuleni.businessbanking@standardbank.co.za",
            },
            {
                name: "CityOfJohannesburg",
                email: "COJ.businessbanking@standardbank.co.za",
            },
            {
                name: "CityOfTshwane",
                email: "tshwane.businessbanking@standardbank.co.za",
            },
            {
                name: "MetswedingDistrict",
                email: "tshwane.businessbanking@standardbank.co.za",
            },
            {
                name: "SedibengDistrict",
                email: "ekurhuleni.businessbanking@standardbank.co.za",
            },
            {
                name: "WestRandDistrict",
                email: "coj.businessbanking@standardbank.co.za ",
            },
        ];
        return _this;
    }
    FormItemReportDeathDetailsV2.prototype.init = function () {
        // form
        this.form = this.element.querySelector("form");
        this.submitBtn = Array.from(this.element.querySelectorAll(".js-reportDeath__button--submit"));
        this.closeButton = this.element.querySelector(".js-apply-now-modal-close");
        this.activeModal = this.element.querySelector("#form-item-report-death-details-v2");
        this.buttonNextStep1 = this.element.querySelector(".next-button-1");
        this.buttonNextStep2 = this.element.querySelector(".next-button-2");
        this.buttonNextStep3 = this.element.querySelector(".next-button-3");
        this.buttonNextStep4 = this.element.querySelector(".submit-button");
        this.showMoreBtn = this.element.querySelector(".data-privacy-collapse-show");
        this.showLessBtn = this.element.querySelector(".data-privacy-collapse-hide");
        this.dataPrivacyDetailArea = this.element.querySelector(".data-privacy-detail");
        this.dataSharingGroupHideBtn = this.element.querySelector(".data-sharing-group-hide-btn");
        this.dataSharingGroupShowBtn = this.element.querySelector(".data-sharing-group-show-btn");
        this.dataSharingGroupTextArea = this.element.querySelector(".data-sharing-group");
        this.dataSharing3rdPartyShowBtn = this.element.querySelector(".data-sharing-3rd-party-show-btn");
        this.dataSharing3rdPartyHideBtn = this.element.querySelector(".data-sharing-3rd-party-hide-btn");
        this.dataSharing3rdPartyTextArea = this.element.querySelector(".data-sharing-3rd-party");
        this.dataSharingBoardersHideBtn = this.element.querySelector(".data-sharing-boarders-hide-btn");
        this.dataSharingBoardersShowBtn = this.element.querySelector(".data-sharing-boarders-show-btn");
        this.dataSharingBoardersTextArea = this.element.querySelector(".data-sharing-boarders");
        // containers
        this.maritalStatusField =
            this.element.querySelector(".js-marital-status");
        this.maritalTypeCont = this.element.querySelector(".js-marital-type-container");
        this.maritalTypeField = this.element.querySelector(".js-marital-type");
        this.identificationTextFieldContainer = this.element.querySelector(".js-id-text-container");
        this.dateOfDeathContainer = this.element.querySelector(".js-date-of-death-container");
        // new code
        this.deceasedCauseOfDeath = "";
        this.dateOfDeathField = this.element.querySelector("input[name=date-of-death]");
        this.causeOfDeathRadioButtons = Array.from(this.element.querySelectorAll("input[name=cause-of-death]"));
        this.executorAppointmentRadioButtons = Array.from(this.element.querySelectorAll("input[name=executor-appointment]"));
        this.identificationTextFieldContainer
            .querySelector("input[name=identification]")
            .setAttribute("maxLength", "25");
        this.identificationTextFieldContainer
            .querySelector("input[name=identification]")
            .setAttribute("length", "25");
        this.causeOfDeathContainer = this.element.querySelector(".js-cause-of-death-container");
        this.causeOfDeathContainer
            .querySelectorAll("input[name=cause-of-death]")
            .forEach(function (el) {
            el.classList.add("js-cause-of-death__radio-group");
        });
        this.causeOfDeathField = Array.from(this.element.querySelectorAll("input[name=cause-of-death]"));
        // New code
        this.executorAppointmentAssistanceOfValues = "";
        this.executorAppointmentAssistanceRadioButtons = Array.from(this.element.querySelectorAll("input[name=executor-appointment-assistance]"));
        this.executorAppointmentAssistanceFields = Array.from(this.element.querySelectorAll("input[name=executor-appointment-assistance]"));
        this.executorAppointmentAssistance = this.element.querySelector(".js-executor-appointment-assistance");
        this.executorAppointmentAssistance
            .querySelectorAll("input[name=executor-appointment-assistance]")
            .forEach(function (el) {
            el.classList.add("js-executor-appointment-assistance_radio--group");
        });
        this.executorAppointmentAssistance.classList.add("form__group--hidden");
        this.executorFirstNameCont = this.element.querySelector(".js-executor-firstname-container");
        this.executorSurnameCont = this.element.querySelector(".js-executor-surname-container");
        this.executorIdNumberCont = this.element.querySelector(".js-executor-id_number-container");
        this.executorEmailCont = this.element.querySelector(".js-executor-email-container");
        this.executorCellphoneCont = this.element.querySelector(".js-executor-cellphone-container");
        this.applyFormRadio = Array.from(this.element.querySelectorAll(".js-identification_radio--group"));
        this.wizard = this.element.querySelector(".form-container-wizard__wizard");
        // New code changes for other field
        this.relationDeceasedType = this.element.querySelector(".js-relation-deceased-status");
        this.relationDeceasedCont = this.element.querySelector(".js-marital-type-container-other");
        this.relationDeceasedTypeOther = this.element.querySelector(".js-relation-deceased-type");
        //Having Email or Not
        this.userRelationHasEmailAddress = this.element.querySelector(".js-user-has-email-address");
        this.userRelationHasEmailAddress
            .querySelectorAll("input[name=user-has-email-address]")
            .forEach(function (el) {
            el.classList.add("js-user-has-email-address_radio--group");
        });
        this.userRelationHasEmailAddressRadioButtonGroup = Array.from(this.element.querySelectorAll(".js-user-has-email-address_radio--group"));
        //Second click
        this.userRelationHasEmailAddressRadioButtonGroup = Array.from(this.element.querySelectorAll("input[name=user-has-email-address]"));
        this.relationEmailAddressContainer = this.element.querySelector(".js-relation-email-address-container");
        this.relationCellPhoneContainer = this.element.querySelector(".js-relation-cellPhone-number-container");
        // New code preferd time to contact
        this.preferedMethodOfContactValue = "";
        this.preferedMethodOfContactRadioButtons = Array.from(this.element.querySelectorAll("input[name=preferred-contact-method]"));
        this.preferedMethodOfContactContainer = this.element.querySelector(".js-preferred-contact-method");
        this.preferedMethodOfContactContainer
            .querySelectorAll("input[name=preferred-contact-method]")
            .forEach(function (el) {
            el.classList.add("js-preferred-contact-method__radio-group");
        });
        this.preferedMethodOfContactField = Array.from(this.element.querySelectorAll("input[name=preferred-contact-method]"));
        // Has Been Executor Radio Button
        this.executorAppointmentOfValues = "";
        this.executorAppointmentOfRadioButtons = Array.from(this.element.querySelectorAll("input[name=executor-appointment]"));
        this.executorAppointment = this.element.querySelector(".js-executor-appointment");
        this.executorAppointment
            .querySelectorAll("input[name=executor-appointment]")
            .forEach(function (el) {
            el.classList.add("js-executor-appointment__radio-group");
        });
        this.supportContactFields = Array.from(this.element.querySelectorAll(".js-support-contact__radio-group"));
        this.executorAppointmentField = Array.from(this.element.querySelectorAll(".js-executor-appointment__radio-group"));
        TooltipsService.initTooltips();
        // buttons
        this.submitBtn = Array.from(this.element.querySelectorAll(".js-reportDeath__button--submit"));
        var formModal = this.element
            .closest(".modal")
            .querySelector(".modal__dialog--small");
        if (formModal) {
            formModal.classList.remove("modal__dialog--small");
            formModal.classList.add("modal__dialog--large");
        }
    };
    FormItemReportDeathDetailsV2.prototype.getDateOfDeath = function (form) {
        var dod = form.querySelector("input[name=date-of-death]");
        var dateSections = dod.value.split("/");
        if (dateSections.length > 0 && dateSections.length <= 3) {
            this.dateValid = this.validateDateOfDeath(dod.value);
        }
        return this.dateValid;
    };
    FormItemReportDeathDetailsV2.prototype.bindEvents = function () {
        var _this = this;
        this.maritalStatusField.addEventListener("change", function (event) {
            var evt = event.target;
            var maritalStatusType = evt.value;
            _this.maritalStatusVal = maritalStatusType;
            if (_this.maritalStatusVal === "MARRIED") {
                _this.maritalTypeCont.classList.remove("form__group--hidden");
            }
            else {
                _this.maritalTypeCont.classList.add("form__group--hidden");
            }
        });
        this.maritalTypeField.addEventListener("change", function (event) {
            var evt = event.target;
            var maritalType = evt.value;
            _this.maritalTypeVal = maritalType;
        });
        if (this.showLessBtn) {
            this.showLessBtn.addEventListener("click", function (e) {
                e.preventDefault();
                _this.showLessBtn.setAttribute("hidden", "true");
                _this.showMoreBtn.removeAttribute("hidden");
                _this.dataPrivacyDetailArea.setAttribute("hidden", "true");
            });
        }
        if (this.showMoreBtn) {
            this.showMoreBtn.addEventListener("click", function (e) {
                e.preventDefault();
                _this.showMoreBtn.setAttribute("hidden", "true");
                _this.showLessBtn.removeAttribute("hidden");
                _this.dataPrivacyDetailArea.removeAttribute("hidden");
            });
        }
        if (this.dataSharingGroupHideBtn) {
            this.dataSharingGroupHideBtn.addEventListener("click", function (e) {
                e.preventDefault();
                _this.dataSharingGroupTextArea.setAttribute("hidden", "true");
                _this.dataSharingGroupHideBtn.setAttribute("hidden", "true");
                _this.dataSharingGroupShowBtn.removeAttribute("hidden");
            });
        }
        if (this.dataSharingGroupShowBtn) {
            this.dataSharingGroupShowBtn.addEventListener("click", function (e) {
                e.preventDefault();
                _this.dataSharingGroupTextArea.removeAttribute("hidden");
                _this.dataSharingGroupHideBtn.removeAttribute("hidden");
                _this.dataSharingGroupShowBtn.setAttribute("hidden", "true");
            });
        }
        if (this.dataSharing3rdPartyHideBtn) {
            this.dataSharing3rdPartyHideBtn.addEventListener("click", function (e) {
                e.preventDefault();
                _this.dataSharing3rdPartyTextArea.setAttribute("hidden", "true");
                _this.dataSharing3rdPartyShowBtn.removeAttribute("hidden");
                _this.dataSharing3rdPartyHideBtn.setAttribute("hidden", "true");
            });
        }
        if (this.dataSharing3rdPartyShowBtn) {
            this.dataSharing3rdPartyShowBtn.addEventListener("click", function (e) {
                e.preventDefault();
                _this.dataSharing3rdPartyTextArea.removeAttribute("hidden");
                _this.dataSharing3rdPartyHideBtn.removeAttribute("hidden");
                _this.dataSharing3rdPartyShowBtn.setAttribute("hidden", "true");
            });
        }
        if (this.dataSharingBoardersShowBtn) {
            this.dataSharingBoardersShowBtn.addEventListener("click", function (e) {
                e.preventDefault();
                _this.dataSharingBoardersTextArea.removeAttribute("hidden");
                _this.dataSharingBoardersShowBtn.setAttribute("hidden", "true");
                _this.dataSharingBoardersHideBtn.removeAttribute("hidden");
            });
        }
        if (this.dataSharingBoardersHideBtn) {
            this.dataSharingBoardersHideBtn.addEventListener("click", function (e) {
                e.preventDefault();
                _this.dataSharingBoardersTextArea.setAttribute("hidden", "true");
                _this.dataSharingBoardersHideBtn.setAttribute("hidden", "true");
                _this.dataSharingBoardersShowBtn.removeAttribute("hidden");
            });
        }
        // New code changes  for other filed
        this.relationDeceasedType.addEventListener("change", function (event) {
            var evt = event.target;
            var typeOfrelation = evt.value;
            _this.typeOfrelationValue = typeOfrelation;
            if (_this.typeOfrelationValue === "OTHER") {
                _this.relationDeceasedCont.classList.remove("form__group--hidden");
            }
            else {
                _this.relationDeceasedCont.classList.add("form__group--hidden");
            }
        });
        this.relationDeceasedTypeOther.addEventListener("change", function (event) {
            var evt = event.target;
            var maritalType = evt.value;
            _this.typeOfrelationValue = maritalType;
        });
        this.userRelationHasEmailAddressRadioButtonGroup.map(function (item) {
            return item.addEventListener("click", function (event) {
                var evt = event.target;
                var emailYesType = evt.value;
                _this.emailYesNoFieldVal = emailYesType;
                if (emailYesType === "YES") {
                    _this.relationEmailAddressContainer.classList.remove("form__group--hidden");
                    _this.relationCellPhoneContainer.classList.remove("form__group--hidden");
                    _this.needForEstateAdministerVal = "YES";
                }
                else {
                    _this.relationEmailAddressContainer.classList.add("form__group--hidden");
                    _this.relationCellPhoneContainer.classList.remove("form__group--hidden");
                    _this.needForEstateAdministerVal = "NO";
                }
            });
        });
        // Event Listner for DeathofCause
        this.causeOfDeathRadioButtons.map(function (item) {
            return item.addEventListener("click", function (event) {
                var evt = event.target;
                var causeOfDeathType = evt.value;
                _this.deceasedCauseOfDeath = causeOfDeathType;
            });
        });
        // Event Listner for PreferedMethodforCall
        this.preferedMethodOfContactRadioButtons.map(function (item) {
            return item.addEventListener("click", function (event) {
                var evt = event.target;
                var preferedMethodForCall = evt.value;
                _this.preferedMethodOfContactValue = preferedMethodForCall;
            });
        });
        // Event Listner for HasBeenExecutor
        this.executorAppointmentOfRadioButtons.map(function (item) {
            return item.addEventListener("click", function (event) {
                var evt = event.target;
                var executorValues = evt.value;
                _this.executorAppointmentOfValues = executorValues;
            });
        });
        // Event Listner for ExecutorRepoter
        this.executorAppointmentAssistanceRadioButtons.map(function (item) {
            return item.addEventListener("click", function (event) {
                var evt = event.target;
                var executorAppValues = evt.value;
                _this.executorAppointmentAssistanceOfValues = executorAppValues;
            });
        });
        if (this.buttonNextStep1) {
            this.buttonNextStep1.addEventListener("click", function (event) {
                if (!_this.getDateOfDeath(_this.form)) {
                    event.stopImmediatePropagation(); // stop from going to next step
                }
                if (!_this.validateCauseOfDeath()) {
                    event.stopImmediatePropagation(); // Stop from going to next step
                }
            });
        }
        if (this.buttonNextStep2) {
            this.buttonNextStep2.addEventListener("click", function (event) {
                if (!_this.validatePreferedMethodToContact()) {
                    event.stopImmediatePropagation(); // Stop from going to next step
                }
                if (!_this.validateEmailAddressCheck()) {
                    event.stopImmediatePropagation();
                }
            });
        }
        if (this.buttonNextStep3) {
            this.buttonNextStep3.addEventListener("click", function (event) {
                if (!_this.validateExecutorAppointment()) {
                    event.stopImmediatePropagation();
                }
                if (!_this.validateExecutoBeenAppointed()) {
                    event.stopImmediatePropagation();
                }
            });
        }
        if (this.buttonNextStep4) {
            this.buttonNextStep4.addEventListener("click", function (event) {
                if (!_this.validateExecutoBeenAppointed()) {
                    event.stopImmediatePropagation();
                }
                if (!_this.validateExecutorAppointmentAssistance()) {
                    event.stopImmediatePropagation();
                }
            });
        }
        this.executorAppointmentOfRadioButtons.map(function (item) {
            return item.addEventListener("click", function (event) {
                var evt = event.target;
                var executorAppType = evt.value;
                _this.executorAppointmentVal = executorAppType;
                if (executorAppType === "NO") {
                    _this.executorAppointmentAssistance.classList.add("form__group--hidden");
                    _this.executorFirstNameCont.classList.add("form__group--hidden");
                    _this.executorSurnameCont.classList.add("form__group--hidden");
                    _this.executorIdNumberCont.classList.add("form__group--hidden");
                    _this.executorEmailCont.classList.add("form__group--hidden");
                    _this.executorCellphoneCont.classList.add("form__group--hidden");
                    _this.needForEstateAdministerVal = "NO";
                }
                else {
                    _this.executorAppointmentAssistance.classList.remove("form__group--hidden");
                    // const executorAppTypeAssValue = this.executorAppointmentAssistance.click();
                    // executorAppTypeAss = executorAppTypeAssValue;
                    _this.needForEstateAdministerVal = "YES";
                }
            });
        });
        var executorAppTypeAss = "";
        this.executorAppointmentAssistanceFields.map(function (item) {
            return item.addEventListener("click", function (event) {
                var evt = event.target;
                executorAppTypeAss = evt.value;
                _this.executorAppointmentVal = executorAppTypeAss;
                if (executorAppTypeAss === "NO") {
                    _this.executorFirstNameCont.classList.remove("form__group--hidden");
                    _this.executorSurnameCont.classList.remove("form__group--hidden");
                    _this.executorIdNumberCont.classList.remove("form__group--hidden");
                    _this.executorEmailCont.classList.remove("form__group--hidden");
                    _this.executorCellphoneCont.classList.remove("form__group--hidden");
                    _this.needForEstateAdministerVal = "NO";
                }
                else {
                    _this.executorFirstNameCont.classList.add("form__group--hidden");
                    _this.executorSurnameCont.classList.add("form__group--hidden");
                    _this.executorIdNumberCont.classList.add("form__group--hidden");
                    _this.executorEmailCont.classList.add("form__group--hidden");
                    _this.executorCellphoneCont.classList.add("form__group--hidden");
                    _this.needForEstateAdministerVal = "YES";
                }
            });
        });
        this.executorAppointmentField.map(function (item) {
            return item.addEventListener("click", function (event) {
                var evt = event.target;
                var assistanceType = evt.value;
                if (assistanceType === "" || assistanceType === undefined) {
                    _this.needForEstateAdministerVal = "NO";
                }
                else {
                    _this.needForEstateAdministerVal = assistanceType;
                }
            });
        });
        // Code for step last
        this.userRelationHasEmailAddressRadioButtonGroup.map(function (item) {
            return item.addEventListener("click", function (event) {
                var evt = event.target;
                var supportContactOption = evt.value;
                _this.supportLikeToContactVal = supportContactOption;
            });
        });
        this.applyFormRadio.map(function (item) {
            return item.addEventListener("click", function (event) {
                var evt = event.target;
                var identificationField = _this.form.querySelector("input[name=identification]");
                var identificationType = evt.value;
                _this.idRadioButtonVal = identificationType;
                if (identificationType === "IDNUMBER") {
                    identificationField.classList.remove("form__input--identification--passport");
                    identificationField.classList.add("form__input--identification");
                    identificationField.placeholder =
                        "Enter a valid South African ID number";
                    _this.identificationTextFieldContainer.querySelector(".form__label").innerHTML = "South African ID";
                    _this.identificationTextFieldContainer
                        .querySelector("input[name=identification]")
                        .setAttribute("maxLength", "25");
                    _this.identificationTextFieldContainer
                        .querySelector("input[name=identification]")
                        .setAttribute("pattern", "d*");
                    identificationField.type = "text";
                }
                else {
                    identificationField.classList.remove("form__input--identification");
                    identificationField.classList.add("form__input--identification--passport");
                    identificationField.placeholder =
                        "Enter your Passport number";
                    _this.identificationTextFieldContainer.querySelector(".form__label").innerHTML = "Passport number";
                    _this.identificationTextFieldContainer
                        .querySelector("input[name=identification]")
                        .setAttribute("maxLength", "25");
                    _this.identificationTextFieldContainer
                        .querySelector("input[name=identification]")
                        .setAttribute("length", "25");
                    identificationField.type = "text";
                }
            });
        });
        this.submitBtn.map(function (item) {
            return item.addEventListener("click", function (event) {
                var _button = event.target;
                var _form = _button.closest("form");
                var formFields = _form.querySelectorAll("input, select");
                _this.validationService.validate(formFields);
                var valid = Array.from(_form.querySelectorAll(".form__group--error"));
                if (valid.length === 0) {
                    _this.submitForm(_form);
                }
            });
        });
        if (this.form) {
            var _formFields = Array.from(this.form.querySelectorAll("input, select, textarea, radio, text"));
            if (_formFields) {
                _formFields.forEach(function (pElement) {
                    pElement.addEventListener("blur", function (pEvent) {
                        if (pEvent.currentTarget['name'] != 'date-of-death')
                            _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
        }
        // Reset the form
        this.form.addEventListener("custom_form_reset_event", function (e) {
            if (_this.wizard) {
                var event_1 = new CustomEvent("custom_wizard_reset_event");
                _this.wizard.dispatchEvent(event_1);
            }
        }, false);
    };
    FormItemReportDeathDetailsV2.prototype.validateDateOfDeath = function (value) {
        var selectionArray = [];
        var dateOfDeathErrorDetails = "Date of death can\u2019t be in the future.";
        var isValid = true;
        var datePassed = new Date(value);
        var todaysDate = new Date();
        var dateOfDeathGroup = this.dateOfDeathField.closest(".form__group");
        selectionArray.push(dateOfDeathGroup);
        // Clear errors
        selectionArray.forEach(function (groupItem) {
            groupItem.classList.remove("form__group--error");
            var errorMessage = groupItem.querySelector(".form__group--error_message");
            if (errorMessage) {
                errorMessage.remove();
            }
        });
        if (!dateOfDeathGroup.classList.contains("form__group--hidden")) {
            if (datePassed > todaysDate) {
                isValid = false;
                this.dateOfDeathContainer.classList.add("form__group--error");
                dateOfDeathGroup.classList.add("form__group--error");
                var _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _errors = document.createElement("ul");
                _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _error = document.createElement("li");
                _error.innerHTML = dateOfDeathErrorDetails;
                _errors.appendChild(_error);
                _errorDiv.appendChild(_errors);
                this.dateOfDeathContainer.appendChild(_errorDiv);
            }
        }
        return isValid;
    };
    FormItemReportDeathDetailsV2.prototype.updateSuccessEmail = function (pId, split) {
        var _emailAddress = "";
        if (split === "CST") {
            for (var i = 0; i < this.emailAddress.length; i++) {
                if (this.emailAddress[i].name === _emailAddress) {
                    _emailAddress = this.emailAddress[i].email;
                    break;
                }
            }
        }
        else {
            _emailAddress = "DeceasedQueries@standardbank.co.za";
        }
        var _emailLink = this.element.querySelector("span.js-report-death__email");
        _emailLink.innerHTML = "";
        var _subject = "Documentation for application: ";
        var _body = "To Whom It May Concern\n\nAttached please find a copy of the following documents as requested:\n\nDeceased's Death Certificate(JPG, PNG OR PDF)";
        var _mailToText = "mailto:" + _emailAddress + "?subject=" +
            encodeURIComponent(_subject) +
            "&body=" +
            encodeURIComponent(_body);
        var _newButton = document.createElement("a");
        _newButton.textContent = "EMAIL DOCUMENTS";
        _newButton.setAttribute("style", "color:white;");
        _newButton.setAttribute("data-id", "link_content_ documents email click");
        _newButton.setAttribute("data-text", "email documents button click");
        _newButton.setAttribute("href", _mailToText);
        _emailLink.appendChild(_newButton);
    };
    FormItemReportDeathDetailsV2.prototype.closeModal = function () {
        this.analyticsService.dtmFormAbandon();
    };
    FormItemReportDeathDetailsV2.prototype.validateExecutorAppointment = function () {
        var selectionArray = [];
        var radioErrorDetails = "This field is required";
        var isValid = true;
        // Radio Details Selection Error
        var executorAppointmentRadiosGroup = this.executorAppointmentRadioButtons[0].closest(".form__group");
        selectionArray.push(executorAppointmentRadiosGroup);
        // Clear errors
        selectionArray.forEach(function (groupItem) {
            groupItem.classList.remove("form__group--error");
            var errorMessage = groupItem.querySelector(".form__group--error_message");
            if (errorMessage) {
                errorMessage.remove();
            }
        });
        // Radio Details Selection Error
        if (!executorAppointmentRadiosGroup.classList.contains("form__group--hidden")) {
            if (this.executorAppointmentVal === "" ||
                this.executorAppointmentVal === undefined) {
                isValid = false;
                executorAppointmentRadiosGroup.classList.add("form__group--error");
                var _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _errors = document.createElement("ul");
                _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _error = document.createElement("li");
                _error.innerHTML = radioErrorDetails;
                _errors.appendChild(_error);
                _errorDiv.appendChild(_errors);
                executorAppointmentRadiosGroup.appendChild(_errorDiv);
            }
        }
        return isValid;
    };
    FormItemReportDeathDetailsV2.prototype.validateExecutorAppointmentAssistance = function () {
        var selectionArray = [];
        var radioErrorDetails = "This field is required";
        var isValid = true;
        // Radio Details Selection Error
        var executorAppointmentAssistanceRadiosGroup = this.executorAppointmentAssistanceRadioButtons[0].closest(".form__group");
        selectionArray.push(executorAppointmentAssistanceRadiosGroup);
        // Clear errors
        selectionArray.forEach(function (groupItem) {
            groupItem.classList.remove("form__group--error");
            var errorMessage = groupItem.querySelector(".form__group--error_message");
            if (errorMessage) {
                errorMessage.remove();
            }
        });
        // Radio Details Selection Error
        if (!executorAppointmentAssistanceRadiosGroup.classList.contains("form__group--hidden")) {
            if (this.executorAppointmentAssistanceOfValues === "" ||
                this.executorAppointmentAssistanceOfValues === undefined) {
                isValid = false;
                executorAppointmentAssistanceRadiosGroup.classList.add("form__group--error");
                var _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _errors = document.createElement("ul");
                _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _error = document.createElement("li");
                _error.innerHTML = radioErrorDetails;
                _errors.appendChild(_error);
                _errorDiv.appendChild(_errors);
                executorAppointmentAssistanceRadiosGroup.appendChild(_errorDiv);
            }
        }
        return isValid;
    };
    FormItemReportDeathDetailsV2.prototype.validateExecutoBeenAppointed = function () {
        var selectionArray = [];
        var radioErrorDetails = "This field is required";
        var isValid = true;
        // Radio Details Selection Error
        var supportContactRadioGroup = this.executorAppointmentOfRadioButtons[0].closest(".form__group");
        selectionArray.push(supportContactRadioGroup);
        // Clear errors
        selectionArray.forEach(function (groupItem) {
            groupItem.classList.remove("form__group--error");
            var errorMessage = groupItem.querySelector(".form__group--error_message");
            if (errorMessage) {
                errorMessage.remove();
            }
        });
        // Radio Details Selection Error
        if (!supportContactRadioGroup.classList.contains("form__group--hidden")) {
            if (this.executorAppointmentOfValues === "" ||
                this.executorAppointmentOfValues === undefined) {
                isValid = false;
                supportContactRadioGroup.classList.add("form__group--error");
                var _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _errors = document.createElement("ul");
                _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _error = document.createElement("li");
                _error.innerHTML = radioErrorDetails;
                _errors.appendChild(_error);
                _errorDiv.appendChild(_errors);
                supportContactRadioGroup.appendChild(_errorDiv);
            }
        }
        return isValid;
    };
    FormItemReportDeathDetailsV2.prototype.validateCauseOfDeath = function () {
        var selectionArray = [];
        var radioErrorDetails = "This field is required";
        var isValid = true;
        // Radio Details Selection Error
        var causeOfDeathRadiosGroup = this.causeOfDeathRadioButtons[0].closest(".form__group");
        selectionArray.push(causeOfDeathRadiosGroup);
        // Clear errors
        selectionArray.forEach(function (groupItem) {
            groupItem.classList.remove("form__group--error");
            var errorMessage = groupItem.querySelector(".form__group--error_message");
            if (errorMessage) {
                errorMessage.remove();
            }
        });
        // Radio Details Selection Error
        if (!causeOfDeathRadiosGroup.classList.contains("form__group--hidden")) {
            if (this.deceasedCauseOfDeath === "") {
                isValid = false;
                causeOfDeathRadiosGroup.classList.add("form__group--error");
                var _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _errors = document.createElement("ul");
                _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _error = document.createElement("li");
                _error.innerHTML = radioErrorDetails;
                _errors.appendChild(_error);
                _errorDiv.appendChild(_errors);
                causeOfDeathRadiosGroup.appendChild(_errorDiv);
            }
        }
        return isValid;
    };
    FormItemReportDeathDetailsV2.prototype.validateEmailAddressCheck = function () {
        var selectionArray = [];
        var radioErrorDetails = "This field is required";
        var isValid = true;
        // Radio Details Selection Error
        var emailAddressCheckRadiosGroup = this.userRelationHasEmailAddressRadioButtonGroup[0].closest(".form__group");
        selectionArray.push(emailAddressCheckRadiosGroup);
        // Clear errors
        selectionArray.forEach(function (groupItem) {
            groupItem.classList.remove("form__group--error");
            var errorMessage = groupItem.querySelector(".form__group--error_message");
            if (errorMessage) {
                errorMessage.remove();
            }
        });
        // Radio Details Selection Error
        if (!emailAddressCheckRadiosGroup.classList.contains("form__group--hidden")) {
            if (this.emailYesNoFieldVal === "" ||
                this.emailYesNoFieldVal === undefined) {
                isValid = false;
                emailAddressCheckRadiosGroup.classList.add("form__group--error");
                var _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _errors = document.createElement("ul");
                _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _error = document.createElement("li");
                _error.innerHTML = radioErrorDetails;
                _errors.appendChild(_error);
                _errorDiv.appendChild(_errors);
                emailAddressCheckRadiosGroup.appendChild(_errorDiv);
            }
        }
        return isValid;
    };
    FormItemReportDeathDetailsV2.prototype.validatePreferedMethodToContact = function () {
        var selectionArray = [];
        var radioErrorDetails = "This field is required";
        var isValid = true;
        // Radio Details Selection Error
        var methodOfContactRadioGroup = this.preferedMethodOfContactRadioButtons[0].closest(".form__group");
        selectionArray.push(methodOfContactRadioGroup);
        // Clear errors
        selectionArray.forEach(function (groupItem) {
            groupItem.classList.remove("form__group--error");
            var errorMessage = groupItem.querySelector(".form__group--error_message");
            if (errorMessage) {
                errorMessage.remove();
            }
        });
        // Radio Details Selection Error
        if (!methodOfContactRadioGroup.classList.contains("form__group--hidden")) {
            if (this.preferedMethodOfContactValue === "" ||
                this.preferedMethodOfContactValue === undefined) {
                isValid = false;
                methodOfContactRadioGroup.classList.add("form__group--error");
                var _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _errors = document.createElement("ul");
                _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _error = document.createElement("li");
                _error.innerHTML = radioErrorDetails;
                _errors.appendChild(_error);
                _errorDiv.appendChild(_errors);
                methodOfContactRadioGroup.appendChild(_errorDiv);
            }
        }
        return isValid;
    };
    FormItemReportDeathDetailsV2.prototype.getDataConsentValue = function (form, selector) {
        var radioBtn = form.querySelector("input[name=\"" + selector + "\"]:checked");
        if (radioBtn && radioBtn.checked) {
            return radioBtn.value.toUpperCase();
        }
        else {
            return null;
        }
    };
    FormItemReportDeathDetailsV2.prototype.submitForm = function (form) {
        // success screens
        var loader = form.querySelector(".form__loader--container");
        var thankYou = form.querySelector(".form__thankyou--container");
        // additional containers
        var success = form.querySelector(".form__success--container");
        var error = form.querySelector(".form__error--container");
        var name = Array.from(form.querySelectorAll(".form__success-container__firstname"));
        var _initialForm = form.querySelector(".form__fields--container");
        // loader + hide form
        loader.classList.add("active");
        _initialForm.classList.add("hidden");
        _initialForm.classList.remove("active");
        var emailPostData = "";
        var postData;
        var _analyticsFlag = document.querySelector(".splitFlag");
        var _split = _analyticsFlag ? "CST" : "DFC";
        emailPostData += "splitFlag=" + (_analyticsFlag ? "CST" : "DFC");
        // hidden fields
        var description = form.querySelector("input[name=description]");
        emailPostData +=
            "description=" + (description ? description.value : "");
        var email = form.querySelector("input[name=email]");
        emailPostData += "&email=" + (email ? email.value : "");
        var recipient = form.querySelector("input[name=recipient]");
        emailPostData += "&recipient=" + (recipient ? recipient.value : "");
        var subject = form.querySelector("input[name=subject]");
        emailPostData += "&subject=" + (subject ? subject.value : "");
        var product = form.querySelector("input[name=product]");
        emailPostData += "&product=" + (product ? product.value : "");
        var redirect = form.querySelector("input[name=redirect]");
        emailPostData += "&redirect=" + (redirect ? redirect.value : "");
        // form fields
        // Deceased Details
        var _deceasedTitle = form.querySelector("select[name=deceased-title]");
        emailPostData +=
            "&deceasedTitle=" + (_deceasedTitle ? _deceasedTitle.value : "");
        var _deceasedFirstName = form.querySelector("input[name=deceased-first-name]");
        emailPostData +=
            "&deceasedFirstName=" +
                (_deceasedFirstName ? _deceasedFirstName.value : "");
        var _deceasedSurname = form.querySelector("input[name=deceased-surname]");
        emailPostData +=
            "&deceasedSurname=" +
                (_deceasedSurname ? _deceasedSurname.value : "");
        var _deceasedIdType = form.querySelector("input[name=identification-type]");
        emailPostData +=
            "&deceasedIdentityType=" +
                (_deceasedIdType ? _deceasedIdType.value : "");
        var _deceasedIdNumber = form.querySelector("input[name=identification]");
        emailPostData +=
            "&deceasedIdnumber=" +
                (_deceasedIdNumber ? _deceasedIdNumber.value : "");
        var _deceasedGender = form.querySelector("select[name=deceased-gender]");
        emailPostData +=
            "&deceasedGender=" + (_deceasedGender ? _deceasedGender.value : "");
        var _deceasedMaritalStatus = form.querySelector("select[name=marital-status]");
        emailPostData +=
            "&deceasedMaritalStatus=" +
                (_deceasedMaritalStatus ? _deceasedMaritalStatus.value : "");
        var _deceasedDateOfDeath = form.querySelector("input[name=date-of-death]");
        var dateParts = _deceasedDateOfDeath.value.split("/");
        var newDate = "";
        if (dateParts.length > 0 && dateParts.length <= 3) {
            newDate = dateParts[2] + "/" + dateParts[1] + "/" + dateParts[0];
        }
        emailPostData +=
            "&deceasedDateOfDeath=" +
                (_deceasedDateOfDeath ? _deceasedDateOfDeath.value : "");
        var _deceasedCauseOfDeath = form.querySelector("input[name=cause-of-death]");
        emailPostData +=
            "&deceasedCauseOfDeath=" +
                (_deceasedCauseOfDeath ? _deceasedCauseOfDeath.value : "");
        // Notifier Details
        var _notifierFirstName = form.querySelector("input[name=reporting-first-name]");
        emailPostData +=
            "&notifierName=" +
                (_notifierFirstName ? _notifierFirstName.value : "");
        var _notifierSurname = form.querySelector("input[name=reporting-surname]");
        emailPostData +=
            "&notifierSurname=" +
                (_notifierSurname ? _notifierSurname.value : "");
        var _notifierIdNumber = form.querySelector("input[name=reporting-id-number]");
        emailPostData +=
            "&notifierIdnumber=" +
                (_notifierIdNumber ? _notifierIdNumber.value : "");
        var _notifierRelationToDeceased = form.querySelector("select[name=relation-to-deceased]");
        emailPostData +=
            "&notifierRelationToDeceased=" +
                (_notifierRelationToDeceased
                    ? _notifierRelationToDeceased.value
                    : "");
        //New Field added
        var _notifierRelationToDeceasedOther = form.querySelector("input[name=relation-to-deceased-type]");
        emailPostData +=
            "&notifierRelationToDeceasedOther=" +
                (_notifierRelationToDeceasedOther
                    ? _notifierRelationToDeceasedOther.value
                    : "");
        var _notifierEmail = form.querySelector("input[name=reporting-email-address]");
        emailPostData +=
            "&notifierEmailAddress=" +
                (_notifierEmail ? _notifierEmail.value : "");
        var _notifierMobile = form.querySelector("input[name=reporting-phone-number]");
        emailPostData +=
            "&notifierMobilenumber=" +
                (_notifierMobile ? _notifierMobile.value : "");
        // Executor Details
        var _isExecutorAdministerEstate = form.querySelector("input[name=executor-appointment]");
        emailPostData +=
            "&isExecutorAdminsterEstate=" +
                (_isExecutorAdministerEstate
                    ? _isExecutorAdministerEstate.value
                    : "");
        var _isNeedForAdminsteringEstate = form.querySelector("input[name=executor-appointment-assistance]");
        emailPostData +=
            "&isNeedForAdminsteringEstate=" +
                (_isNeedForAdminsteringEstate
                    ? _isNeedForAdminsteringEstate.value
                    : "");
        var _executorFirstName = form.querySelector("input[name=executor-first-name]");
        emailPostData +=
            "&executorName=" +
                (_executorFirstName ? _executorFirstName.value : "");
        var _executorSurname = form.querySelector("input[name=executor-surname]");
        emailPostData +=
            "&executorSurname=" +
                (_executorSurname ? _executorSurname.value : "");
        var _executorIdNumber = form.querySelector("input[name=executor-id-number]");
        emailPostData +=
            "&executorIdnumber=" +
                (_executorIdNumber ? _executorIdNumber.value : "");
        var _executorEmail = form.querySelector("input[name=executor-email-address]");
        emailPostData +=
            "&executorEmailAddress=" +
                (_executorEmail ? _executorEmail.value : "");
        var _executorMobile = form.querySelector("input[name=executor-phone-number]");
        emailPostData +=
            "&executorMobilenumber=" +
                (_executorMobile ? _executorMobile.value : "");
        var _preferedMethodOfContact = form.querySelector("input[name=preferred-contact-method]");
        emailPostData +=
            "&preferedContactMethod=" +
                (_preferedMethodOfContact ? _preferedMethodOfContact.value : "");
        var _popiaConsent = form.querySelector("input[name=popia-consent]");
        postData = {
            deceasedTitle: _deceasedTitle.value,
            deceasedName: _deceasedFirstName.value,
            deceasedSurname: _deceasedSurname.value,
            deceasedIdentityType: this.idRadioButtonVal,
            deceasedIdnumber: _deceasedIdNumber.value,
            deceasedGender: _deceasedGender.value,
            deceasedMaritalStatus: this.maritalStatusVal,
            deceasedMaritalType: this.maritalTypeVal,
            deceasedDateOfDeath: newDate,
            deceasedCauseOfDeath: this.deceasedCauseOfDeath,
            notifierName: _notifierFirstName.value,
            notifierSurname: _notifierSurname.value,
            notifierRelationToDeceased: _notifierRelationToDeceased.value,
            notifierRelationToDeceasedOther: _notifierRelationToDeceasedOther.value,
            notifierIdnumber: _notifierIdNumber.value,
            notifierEmailAddress: _notifierEmail.value,
            notifierMobilenumber: _notifierMobile.value,
            preferedContactMethod: this.preferedMethodOfContactValue,
            isExecutorAdminsterEstate: this.executorAppointmentVal,
            isNeedForAdminsteringEstate: this.needForEstateAdministerVal,
            executorName: _executorFirstName.value,
            executorSurname: _executorSurname.value,
            executorIdnumber: _executorIdNumber.value,
            executorEmailAddress: _executorEmail.value,
            executorMobilenumber: _executorMobile.value,
            dataPrivacyConsent: _popiaConsent
                ? _popiaConsent.checked
                    ? "YES"
                    : "NO"
                : "NO",
            dataSharingWithinOurGrpMarketingConsent: this.getDataConsentValue(form, "data-sharing-group"),
            dataSharingWithThirdPartiesMarketingConsent: this.getDataConsentValue(form, "data-sharing-3rd-party"),
            dataSharingAcrossBordersWithinOurGrpMarketingConsent: this.getDataConsentValue(form, "data-sharing-boarders"),
        };
        if (name) {
            name.map(function (_item) {
                _item.innerHTML = _notifierFirstName.value;
            });
        }
        // variables
        var analyticsService = new AnalyticsService();
        var url = this.baseUrl + "/leadsutils/createDeceasedEstate";
        var config = {
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Access-Control-Allow-Origin": "*",
                "X-Requested-With": "XMLHttpRequest",
            },
        };
        JSON.stringify(postData);
        // service
        this.formsService
            .postForm(url, postData, config)
            .then(function (response) {
            loader.classList.remove("active");
            // Always show success message / no response from server (sending email)
            analyticsService.dtmFormComplete("complete", response.code, false, "", _notifierEmail.value, _notifierMobile.value);
            thankYou.classList.add("active");
            error.classList.remove("active");
            error.classList.add("hidden");
            success.classList.remove("hidden");
            success.classList.add("active");
            // this.updateSuccessEmail( _deceasedIdNumber.value, _split);
        })
            .catch(function (response) {
            // service failed
            analyticsService.dtmRecordSiteError("noerrorcode|service failure occured|" + url);
            loader.classList.remove("active");
            _initialForm.classList.remove("hidden");
        });
    };
    return FormItemReportDeathDetailsV2;
}(Base));
export { FormItemReportDeathDetailsV2 };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-report-death-details-v2/form-item-report-death-details-v2.component.ts
// module id = 964
// module chunks = 0